import { useState, useEffect, useMemo } from 'react';
import { isMobile as isMobileDevice } from 'util/screen';

export default function useWindowSize({ largeMobile = false } = {}) {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });
  const [isMobile, setIsMobile] = useState(isMobileDevice({ largeMobile }));

  const initialDevice = useMemo(
    () => (isMobileDevice({ largeMobile }) ? 'mobile' : 'desktop'),
    [largeMobile]
  );

  const currentDevice = useMemo(
    () => (isMobileDevice({ largeMobile }) ? 'mobile' : 'desktop'),
    [windowSize, largeMobile]
  );

  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;

      setWindowSize({
        width,
        height: window.innerHeight
      });
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setIsMobile(isMobileDevice({ largeMobile }));
  }, [windowSize]);

  const sizeInfo = useMemo(
    () => ({ isMobile, initialDevice, currentDevice }),
    [isMobile, initialDevice, currentDevice]
  );

  return [windowSize, sizeInfo];
}
